const styles = {
  activo: 'border-success/30 bg-success/10 text-success-text',
  pendiente: 'border-pending/30 bg-pending/10 text-pending',
  inactivo: 'border-danger/25 bg-danger/10 text-danger',
}

const labels = { activo: 'Activo', pendiente: 'Pendiente', inactivo: 'Inactivo' }

export default function EstadoSocioBadge({ estado }) {
  return (
    <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${styles[estado] || 'border-border bg-background text-text-secondary'}`}>
      {labels[estado] || estado || 'Sin estado'}
    </span>
  )
}
